<div class="slider-main-container">
  <div class="slider">
    <div class="slide" *ngFor="let s of slides" [ngClass]="s.title === selectedSlide?.title ? 'selected' : ''"
      (click)="selectSlide(s)">
      <img [src]="s.imgUrl" appHoverExpand>
    </div>
  </div>
</div>
